export enum InvestigationSignedMinutesStatus {
	Required = "SIGNED_MINUTES_REQUIRED",
	UploadedSessionEnded = "MINUTES_UPLOADED_SESSION_ENDED",
	CancelledSession = "NO_MINUTES_FOR_CANCELLED_SESSION",
}
